import a from "react";
import r from "hoist-non-react-statics";
const { Consumer: s, Provider: m } = a.createContext(!1), p = (t) => {
  const e = (c) => /* @__PURE__ */ a.createElement(s, null, (o) => /* @__PURE__ */ a.createElement(
    t,
    {
      inTextInputSelect: o,
      ...c
    }
  ));
  return e.displayName = `WithInTextInputSelect(${t.displayName || t.name || "Component"})`, r(e, t), e;
};
export {
  m as P,
  p as w
};
